<template>
  <el-drawer
    class="sideDrawer"
    destroy-on-close
    :size="drawerSize"
    :close-on-click-modal="false"
    title="开票"
    :visible="detailShow"
    :before-close="closeDetail"
  ><i
      class="iconfont icon-back-quanping iconFull"
      @click="drawerSize = '100%'"
      v-if="drawerSize == '70%'"
    />
    <i
      @click="drawerSize = '70%'"
      class="iconfont icon-back-tuichuquanping iconFull"
      v-else
    />
    <div
      slot="title"
      class="dialog-header-title"
    >
      <span class="name">开票</span>
    </div>
    <div
      class="form_content"
      style="padding: 20px"
    >
      <el-form
        :model="formData"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <div class="titlePart">

          <span>客户信息</span>
        </div>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="发票申请单号:"
              prop="audit_no"
            >
              <el-input
                v-model="formData.audit_no"
                placeholder="保存后自动生成"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="客户名称:"
              prop="customer_name"
            >
              <el-input
                v-model="formData.customer_name"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="联系人:"
              prop="contacts"
            >
              <el-input v-model="formData.contacts"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="联系电话:"
              prop="contacts_phone"
            >
              <el-input v-model="formData.contacts_phone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="地址:"
              prop="receiver_address"
            >
              <el-input v-model="formData.receiver_address"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="邮箱:"
              prop="receiver_meal"
            >
              <el-input v-model="formData.receiver_meal"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="申请发票金额:"
              prop="apply_amount"
            >
              <el-input-number
                :precision="2"
                v-model="formData.apply_amount"
              style="width:100%"
                :min="0"
                :max="9999999999"
                :controls="false"
                disabled
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="发票类型:"
              prop="invoice_type"
            >
              <el-select
              style="width:100%"
                v-model="formData.invoice_type"
                placeholder="请选择"
                @change="accountChange"
              >
                <el-option
                  v-for="item in productList"
                  :key="item.index"
                  :label="item.name"
                  :value="item.key"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="申请日期:"
              prop="apply_date"
            >
              <el-date-picker
                v-model="formData.apply_date"
              style="width:100%"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                disabled
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="titlePart">

          <span>开票信息</span>
        </div>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="发票抬头名称:"
              prop="invoice_title"
            >
              <el-input v-model="formData.invoice_title"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="纳税人识别号:"
              prop="identity_code"
            >
              <el-input v-model="formData.identity_code"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="开户行及账号:"
              prop="bank_account"
            >
              <el-input v-model="formData.bank_account"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="地址电话:"
              prop="address_phone"
            >
              <el-input v-model="formData.address_phone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="titlePart">
          <span>付款单信息</span>
        </div>
        <el-table
          :data="formData.sub_third_invoice_order"
          style="width: 100%"
          max-height="250"
        >
          <el-table-column
            label="序号"
            type="index"
            width="50"
          >
          </el-table-column>
          <el-table-column
            prop="payment_no"
            label="付款单号"
          >
          </el-table-column>
          <el-table-column
            prop="payment_amount"
            label="付款金额"
            :formatter="num_formatter1"
          >
          </el-table-column>
          <el-table-column
            prop="pay_amount"
            label="确认收款"
            :formatter="num_formatter1"
          >
          </el-table-column>
          <!-- <el-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <el-button
                @click.native.prevent="deleteRow(scope.$index, tableData)"
                type="text"
                size="small"
              >
                删除
              </el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </el-form>

    </div>
    <div class="demo-drawer__footer">
      <el-button @click="closeDetail">取消</el-button>
      <el-button
        type="primary"
        @click="submitForm('ruleForm')"
        :loading="loading"
      >保存</el-button>
    </div>
  </el-drawer>
</template>

<script>
import utils from '@/utils.js'
import smallTable from './smallTable.vue'
import { mapState } from 'vuex'
import moment from 'moment'
export default {
  components: { smallTable },
  props: ['show', 'data', 'selectData', 'id'],
  computed: {
    ...mapState({
      allDataDict: (state) => state.user.allDataDict
    })
  },
  data() {
    return {
      tenantId: '',
      productList: [],
      drawerSize: '70%',
      detailShow: false,
      loading: false,
      formData: {
        apply_date: moment(new Date()).format('YYYY-MM-DD')
      },
      rules: {
        receiver_address: [
          { required: true, message: '请输入地址', trigger: 'blur' },
          { max: 200, message: '字数不得超过200', trigger: 'blur' }
        ],
        contacts: [
          { required: true, message: '请输入联系人', trigger: 'blur' },
          { max: 200, message: '字数不得超过200', trigger: 'blur' }
        ],
        contacts_phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { max: 200, message: '字数不得超过200', trigger: 'blur' }
        ],
        receiver_meal: [
          { required: false, message: '请输入邮箱', trigger: 'blur' },
          { max: 200, message: '字数不得超过200', trigger: 'blur' }
        ],
        invoice_title: [
          { required: true, message: '请输入发票抬头名称', trigger: 'blur' },
          { max: 200, message: '字数不得超过200', trigger: 'blur' }
        ],
        identity_code: [
          { required: true, message: '请输入纳税人识别号', trigger: 'blur' },
          { max: 200, message: '字数不得超过200', trigger: 'blur' }
        ],
        invoice_type: [
          {
            required: true,
            message: '请选择发票类型',
            trigger: ['blur', 'change']
          }
        ],
        bank_account: [
          { required: true, message: '请输入开户行及账号', trigger: 'blur' },
          { max: 200, message: '字数不得超过200', trigger: 'blur' }
        ],
        address_phone: [
          { required: true, message: '请输入地址电话', trigger: 'blur' },
          { max: 200, message: '字数不得超过200', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    id: {
      handler(newVal, oldVal) {
        if (newVal) this.getDetail(newVal)
      },
      deep: true,
      immediate: true
    },
    show: {
      handler(newVal, oldVal) {
        this.detailShow = newVal
        this.getProductList()
      },
      deep: true,
      immediate: true
    },
    data: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.formData.customer_name = newVal.customer_name
          this.tenantId = sessionStorage.getItem('tenantId')
          this.formData.customer_id = newVal.customer_id ? newVal.customer_id : this.tenantId
          this.loadFRDetail()
        }
      },
      deep: true,
      immediate: true
    },
    selectData: {
      handler(newVal, oldVal) {
        if (newVal) {
          if (newVal.length) {
            this.formData.apply_amount = 0
            newVal.forEach((e) => {
              if (e.pay_amount) this.formData.apply_amount = this.formData.apply_amount + e.pay_amount
              delete e.tenant_id_
              if (e.id) e.order_id = e.id
              delete e.id
            })
          }
          this.formData.sub_third_invoice_order = newVal
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 获取详情
    getDetail(id) {
      this.$http.get('${third}/costcenter/third_invoice_apply/' + id).then(
        (resp) => {
          if (resp.data) {
            this.formData = resp.data
          }
        },
        (error) => {
          reject(error)
        }
      )
    },
    // 列表千分位格式化
    num_formatter1(row, column, cellValue) {
      if (cellValue || cellValue == 0) {
        return utils.dataTransform(String(cellValue))
      }
    },
    // 获取发票类型列表
    getProductList() {
      this.productList = utils.findDictList('jxfpkplx', this.allDataDict)
    },
    // 删除列
    deleteRow(index, rows) {
      const apply_amount = this.formData.sub_third_invoice_order[index].pay_amount ? this.formData.sub_third_invoice_order[index].pay_amount : 0
      this.$set(this.formData, 'apply_amount', this.formData.apply_amount - apply_amount)
      this.$forceUpdate()
      this.formData.sub_third_invoice_order.splice(index, 1)
    },
    // 保存
    submitForm(formName) {
      this.loading = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.formData.id) {
            this.$http.put('${third}/costcenter/third_invoice_apply/', this.formData).then(
              (resp) => {
                if (resp.data.state) {
                  this.$message.success('保存成功')
                  setTimeout(() => {
                    this.loading = false
                    this.closeDetail(true)
                  }, 100)
                }
              },
              (error) => {
                this.loading = false
                reject(error)
              }
            )
          } else {
            this.$http.post('${third}/costcenter/third_invoice_apply/', this.formData).then(
              (resp) => {
                if (resp.data.state) {
                  this.$message.success('保存成功')
                  setTimeout(() => {
                    this.loading = false
                    this.closeDetail(true)
                  }, 100)
                }
              },
              (error) => {
                this.loading = false
                reject(error)
              }
            )
          }
        } else {
          this.loading = false
          return false
        }
      })
    },
    // 千分位格式化
    num_formatter(cellValue) {
      if (cellValue || cellValue == 0) {
        return utils.dataTransform(String(cellValue))
      }
    },
    //关闭对话框
    closeDetail(isSave) {
      this.detailShow = false
      this.$emit('closeDetailDialog', isSave)
    },
    // 根据客户带出开票信息
    loadFRDetail() {
      const param = {
        pageBean: { page: 1, pageSize: 500, total: 0 }
      }
      const tenentId = this.tenantId == -1 || !this.tenantId ? this.formData.customer_id : this.tenantId
      this.$http.post('${portal}/system/tenant_corporate_info/query?tenantId=' + tenentId, param).then(
        (resp) => {
          if (resp.data && resp.data.rows && resp.data.rows.length > 0) {
            resp.data.rows.forEach((e) => {
              if (e.default == 1) {
                this.$set(this.formData, 'invoice_title', e.company_name)
                this.$set(this.formData, 'identity_code', e.tax_no)
                this.$set(this.formData, 'bank_account', `${e.bank ? e.bank : ''}` + `${e.bank_no ? e.bank_no : ''}`)
                this.$set(this.formData, 'address_phone', `${e.company_address ? e.company_address : ''}` + `${e.company_tel ? e.company_tel : ''}`)
              }
            })
          }
        },
        (error) => {
          reject(error)
        }
      )
    },
    // 下拉框赋值
    accountChange(val) {
      this.productList.forEach((item) => {
        if (item.key == val) {
          this.formData.invoice_type = item.key
          if (this.formData.invoice_type == 3 || this.formData.invoice_type == 4) {
            this.rules.receiver_meal = [
              { required: true, message: '请输入邮箱', trigger: 'blur' },
              { max: 200, message: '字数不得超过200', trigger: 'blur' }
            ]
          } else {
            this.rules.receiver_meal = [
              { required: false, message: '请输入邮箱', trigger: 'blur' },
              { max: 200, message: '字数不得超过200', trigger: 'blur' }
            ]
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
p {
  padding: 0;
  margin: 0;
}
.detailContent {
  padding-left: 20px;
  padding-right: 20px;
}
.eachItem {
  display: flex;
  .label {
    margin-right: 20px;
    flex-shrink: 0;
  }
  p {
    color: rgba(16, 16, 16, 100);
    font-size: 14px;
    text-align: left;
    line-height: 2;
  }
}
/deep/.el-dialog__body {
  padding-top: 20px;
}
.titlePart {
  display: flex;
  align-content: center;
  margin-bottom: 10px;
  img {
    height: 20px;
  }
  span {
    color: rgba(55, 124, 255, 100);
    font-size: 16px;
    font-weight: bold;
  }
}
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

/deep/ input::-webkit-outer-spin-button {
  -webkit-appearance: none !important;
}

input[type='number'] {
  -moz-appearance: textfield;
}
</style>
